export type MediaViewMode = 'cover' | 'contain';
